import { Tabs } from "@jhool-io/fe-components";
import { useSearchParams } from "react-router-dom";
import CaseloadViewWrapper from "../CaseloadViewWrapper/CaseloadViewWrapper";
import { IClinician } from "../../../types/schedule.types";
import ScheduleViewWrapper from "../ScheduleView/ScheduleViewWrapper";
import moment from "../../../../../utils/moment";

export default function ClinicianViewWrapper() {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentWeek = moment().startOf("week");
    const startOfWeek = currentWeek.startOf("week").format("YYYY-MM-DD");
    const endOfWeek = currentWeek.endOf("week").format("YYYY-MM-DD");

    const handleTabInView = (tab: string) => {
        return setSearchParams(`tab=${tab}`);
    };

    const defaultClinician = {} as IClinician;
    const appointmentChecks = defaultClinician.appointment_checks;
    const confirmedSchedules = (defaultClinician.confirmed ?? []).map(
        (confirmedAppointment) => {
            const appointmentCheck = confirmedAppointment.id
                ? appointmentChecks?.[confirmedAppointment.id]
                : null;

            return {
                ...confirmedAppointment,
                appointment_check: appointmentCheck ?? null,
            };
        }
    );

    const tabInUrl = searchParams.get("tab");
    const tabItems = [
        {
            label: "My Caseload",
            key: "caseload",
            children: <CaseloadViewWrapper schedules={confirmedSchedules} />,
            onClick: () => handleTabInView("caseload"),
        },
        {
            label: "My Schedule",
            key: "schedule",
            children: <ScheduleViewWrapper />,
            onClick: () => {
                handleTabInView("schedule");
                searchParams.set("from_date", startOfWeek);
                searchParams.set("to_date", endOfWeek);
                setSearchParams(searchParams);
            },
        },
    ];

    return (
        <Tabs
            items={tabItems}
            size="medium"
            className="w-full rounded-none"
            defaultActiveKey={tabInUrl || tabItems[0]?.key}
        />
    );
}
